<section class="mb-5">
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ "COL.COURSES.PRODUCTS.AGE_GROUP.ENCFK.TITLE" | translate }}
      </h4>
    </div>
    <div class="card-body">
      <p class="mb-0">
        {{ "COL.COURSES.PRODUCTS.AGE_GROUP.ENCFK.DESC" | translate }}
      </p>
    </div>
  </div>
</section>

<section class="mb-5">
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.ENCFK.TITLE" | translate }}
      </h4>
    </div>
    <div class="card-body">
      <p>
        {{ "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.ENCFK.EXPLANATION" | translate }}
      </p>
      <div class="table-responsive">
        <table class="table white-text pe-none mt-3">
          <thead>
          <tr class="table-row table-row-head">
            <th scope="col">CEFR Level<sup>1</sup></th>
            <th scope="col">Callan for Kids stages</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr class="table-row">
            <td>Beginner</td>
            <td>Stages 1-2</td>
          </tr>
          <tr class="table-row">
            <td>A1</td>
            <td>Stages 3-4</td>
          </tr>
          <tr class="table-row">
            <td>A2</td>
            <td>Stages 5-6</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ol class="text-muted ps-3">
        <li>
          <p class="fw-bold small mb-1">
            {{
            "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.EN.EXAMINATIONS_LIST.CEFR.TITLE"
              | translate
            }}
          </p>
          <p class="xsmall">
            {{
            "COL.COURSES.PRODUCTS.LEVEL_COMPARISON.ENCFK.CEFR_NOTE"
              | translate
            }}
          </p>
        </li>
      </ol>
    </div>
  </div>
</section>

<section class="mb-5">
  <p class="text-center mb-5 h4">
    {{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.TITLE" | translate }}
  </p>
  <div class="row text-center justify-content-center">
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.FREQUENCY.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.FREQUENCY.DESC" | translate }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.PARTICIPATION.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.PARTICIPATION.DESC" | translate }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-xl-4">
      <p>{{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.MOTIVATION.TITLE" | translate }}</p>
      <p class="text-muted">
        {{ "COL.COURSES.PRODUCTS.PROGRESS.ENCFK.MOTIVATION.DESC" | translate }}
      </p>
    </div>
  </div>
</section>
